var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"progress-demo"}},[_c('progress-color'),_c('progress-interminate'),_c('progress-height')],1)}
var staticRenderFns = []

export { render, staticRenderFns }